export default {
  lstTab: {
    overview: 'Giá',
    orderStatistic: 'Đặt lệnh',
    foreign: 'Nước ngoài',
    proprietary: 'Tự Doanh',
  },

  rateList: {
    FromDate: '01/01/2019',
    ToDate: '01/03/2019',
  },

  lstTitleDate: {
    from: 'Từ',
    to: 'Đến',
  },

  defaultRateFrom: 'Từ Ngày',
  defaultRateTo: 'Đến Ngày',

  priceDataTableOverview: {
    DATE: 'NGÀY',
    LAST: 'GIÁ',
    CHANGE: 'THAY ĐỔI',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    OPEN: 'MỞ',
    HIGH: 'CAO',
    LOW: 'THẤP',
    OPEN_INDEX: 'MỞ',
    HIGH_INDEX: 'CAO',
    LOW_INDEX: 'THẤP',
    AVERAGE_PRICE: 'GIÁ TB',
    MATCHED_VOLUME: 'KL<br> KHỚP', // have space after <br>
    MATCHED_VALUE: 'GT<br> KHỚP', // have space after <br>
    PUT_THROUGH_VOL: 'K.L<br> THỎA THUẬN', // have space after <br>
    PUT_THROUGH_VALUE: 'G.T<br> THỎA THUẬN', // have space after <br>
    TOTAL_VOL: 'TỔNG KHỐI LƯỢNG',
    TOTAL_VALUE: 'TỔNG GIÁ TRỊ',
  },

  priceDataTableOrderStatistic: {
    DATE: 'NGÀY',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'GIÁ',
    CHANGE: 'THAY ĐỔI',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    NR_OF_BUY_ORDER: 'SỐ<br> LỆNH MUA', // have space after <br>
    BUY_VOL: 'KL<br> ĐẶT MUA',
    VOLUMN_BUY_ORDER: 'KLTB<br> 1 LỆNH MUA',
    NR_OF_SELL_ORDER: 'SỐ<br> LỆNH BÁN', // have space after <br>
    SELL_VOL: 'KL<br> ĐẶT BÁN',
    VOLUMN_SELL_ORDER: 'KLTB<br> 1 LỆNH BÁN',
    NET_VOL: 'KL<br> MUA-BÁN',
  },

  priceDataTableForeign: {
    DATE: 'NGÀY',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'GIÁ',
    CHANGE: 'THAY ĐỔI',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    BUY_ORDER_VOL: 'KL<br> MUA', // have space after <br>
    BUY_ORDER_VALUE: 'GT<br> MUA', // have space after <br>
    SELL_ORDER_VOL: 'KL<br> BÁN ', // have space after <br>
    SELL_ORDER_VALUE: 'GT<br> BÁN', // have space after <br>
    NET_VOLUME: 'KL<br> RÒNG',
    NET_VALUE: 'GT<br> RÒNG',
    OWNED_RATIO: '%SHNN',
    FOREIGN_ROOM: 'Room Còn lại',
  },

  priceDataTableProprietary: {
    DATE: 'NGÀY',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'GIÁ',
    CHANGE: 'THAY ĐỔI',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    BUY_VOL: 'KL MUA ',
    BUY_VALUE: 'GT MUA',
    SELL_VOL: 'KL BÁN',
    SELL_VALUE: 'GT BÁN',
    NET_VOL: 'KL RÒNG',
    NET_VALUE: 'GT RÒNG',
  },

  listTimeRangeByKey: {
    Daily: 'THEO NGÀY',
    Weekly: 'THEO TUẦN',
    Monthly: 'THEO THÁNG',
    Yearly: 'THEO NĂM',
  },

  indexInfo: {
    Open: 'O',
    Hight: 'H',
    Low: 'L',
    Bid: 'BID',
    Ask: 'ASK',
  },

  footerText1:
    'Giá: x 1,000. Khối Lượng: x 1,000. Giá trị: x 1,000,000. Ngày Thực Hiện được đánh dấu sao',
  footerText2: 'Giá: x 1,000. Khối Lượng: x 1,000. Giá Trị: x 1,000,000',
};
